module.exports = __webpack_public_path__ + "img/google.241631b.svg";